import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'documentState';

export const getAllDocuments = createAsyncThunk(
    'documentState/getAllDocuments',
    async (_, { getState, rejectWithValue, dispatch }) => {
        try {
            const group = getState().deviceState.activeDevice.group;
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/documents?group=${group}`,
                withCredentials: true,
                auth: createAuth(getState)
            });
            // Set first document as active if none is active
            if (getState().documentState.activeDocument === null && response.data.length > 0) {
                dispatch(setActiveDocument(response.data[0]));
            }
            return response.data;
        } catch (error) {
            console.log('ERROR FETCHING DOCUMENTS', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    documents: [],
    activeDocument: null,
    status: 'idle',
    error: null,
};

const documentSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setActiveDocument: (state, action) => {
            state.activeDocument = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllDocuments.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllDocuments.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.documents = action.payload;
            })
            .addCase(getAllDocuments.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export const { setActiveDocument } = documentSlice.actions;

export default documentSlice.reducer;